module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-02-f7a98c6e47ecdb46354ad965a0cf656b.svg";